/**
 * Returns the login URL for the current portal based on pathname.
 * Use when session expires or user is unauthenticated so admin/superadmin
 * stay on their login portal instead of being sent to user login.
 */
export function getLoginRedirectUrl(pathname?: string): string {
  const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  if (path.startsWith('/superadmin') && !path.startsWith('/superadmin/login')) {
    return '/superadmin/login';
  }
  if (path.startsWith('/admin-portal')) {
    return '/admin/login';
  }
  return '/user/login';
}
